// src/components/miscellaneous/ComingSoonModal.js

import React from 'react';

// 🌟 UPGRADED: Dynamic style function mapper accepting explicit theme parameters
const getStyles = (isDarkMode) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isDarkMode ? 'rgba(0, 0, 0, 0.85)' : 'rgba(0, 0, 0, 0.65)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    pointerEvents: 'auto',
    backdropFilter: 'blur(4px)', // Clean high-fidelity glass frosting effect
  },
  modal: {
    backgroundColor: isDarkMode ? '#18181b' : '#FFFFFF', // Zinc-900 midtone vs stark clean white
    color: isDarkMode ? '#f4f4f5' : '#18181b',          // Zinc-100 high contrast vs deep dark text
    padding: '30px',
    borderRadius: '16px', // Modernized curve alignment
    textAlign: 'center',
    width: '90%',
    maxWidth: '350px',
    border: isDarkMode ? '1px solid #27272a' : '1px solid #f4f4f5', // Zinc-800 subtle micro border
    boxShadow: isDarkMode 
      ? '0 20px 25px -5px rgba(0, 0, 0, 0.7), 0 10px 10px -5px rgba(0, 0, 0, 0.5)' 
      : '0 20px 25px -5px rgba(15, 23, 42, 0.15), 0 10px 10px -5px rgba(15, 23, 42, 0.05)',
    transition: 'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
  },
  title: {
    margin: 0,
    marginBottom: '10px',
    fontSize: '22px',
    fontWeight: '900', // Heavy editorial black styling matching Atomic's headline core
    textTransform: 'uppercase',
    letterSpacing: '-0.025em',
    fontStyle: 'italic',
  },
  text: {
    margin: 0,
    marginBottom: '25px',
    fontSize: '13px',
    lineHeight: '1.6',
    fontWeight: '500',
    color: isDarkMode ? '#a1a1aa' : '#52525b', // Balanced zinc tracking tones for optimal legibility
  },
  closeButton: {
    backgroundColor: '#ff00cc', // Atomic signature pink brand element
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 25px',
    fontSize: '11px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    cursor: 'pointer',
    width: '100%',
    boxShadow: '0 4px 14px rgba(255, 0, 204, 0.3)',
    transition: 'transform 0.1s ease, filter 0.2s ease',
  }
});

const ComingSoonModal = ({ isOpen, onClose, isDarkMode }) => {
  if (!isOpen) {
    return null;
  }

  // Generate theme context specific style block mapping handles instantly
  const styles = getStyles(isDarkMode);

  const handleOverlayClick = (e) => {
    if (e.target.id === 'modal-overlay') {
      onClose();
    }
  };

  return (
    <div 
      id="modal-overlay" 
      style={styles.overlay} 
      onClick={handleOverlayClick}
    >
      <div style={styles.modal}>
        <h2 style={styles.title}>Coming Soon</h2>
        <p style={styles.text}>
          We’re working hard to bring you the features you want!
        </p>
        <button 
          style={styles.closeButton} 
          onClick={onClose}
          onMouseEnter={(e) => { e.currentTarget.style.filter = 'brightness(1.1)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.filter = 'none'; }}
          onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; }}
          onMouseUp={(e) => { e.currentTarget.style.transform = 'none'; }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default ComingSoonModal;